import { render, staticRenderFns } from "./BreakingNews.vue?vue&type=template&id=7338d35c&scoped=true"
import script from "./BreakingNews.vue?vue&type=script&lang=js"
export * from "./BreakingNews.vue?vue&type=script&lang=js"
import style0 from "./BreakingNews.vue?vue&type=style&index=0&id=7338d35c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7338d35c",
  null
  
)

export default component.exports